import React, { useState, useEffect } from "react";
import DynamicTable from "../../components/DynamicTable";
import {CheckboxInput } from '../../components/FormInitiators';


// Function to convert date format from dd-MM-yyyy to yyyy-MM-dd
const formatDateToInput = (date) => {
  if (!date) return "";
  const [day, month, year] = date.split("-");
  return `${year}-${month}-${day}`; // Convert to yyyy-MM-dd
};

const ArrearsSeventhForm3 = ({ formData, setFormData, onFormDataChange, onBack, onNext }) => {
  const [selectedPreset, setSelectedPreset] = useState("");


  const handleInputChange = ({ target: { name, value } }) => {
    onFormDataChange({ [name]: value });
  };

  // Define presets for the table with dates in yyyy-MM-dd format
  const presets = {
    "Preset 1": [
      { "dateFrom": "2016-05-01", "tillDate": "2016-05-31" },
      { "dateFrom": "2017-05-01", "tillDate": "2017-05-31" },
      { "dateFrom": "2018-05-01", "tillDate": "2018-05-31" },
      { "dateFrom": "2019-05-01", "tillDate": "2019-05-31" },
      { "dateFrom": "2020-05-01", "tillDate": "2020-05-31" },
      { "dateFrom": "2021-05-01", "tillDate": "2021-05-31" },
      { "dateFrom": "2022-05-01", "tillDate": "2022-05-31" },
      { "dateFrom": "2023-05-01", "tillDate": "2023-05-31" },
      { "dateFrom": "2024-05-01", "tillDate": "2024-05-31" },
      { "dateFrom": "2025-05-01", "tillDate": "2025-05-31" },
      { "dateFrom": "2026-05-01", "tillDate": "2026-05-31" },
      { "dateFrom": "2027-05-01", "tillDate": "2027-05-31" },
      { "dateFrom": "2028-05-01", "tillDate": "2028-05-31" },
      { "dateFrom": "2029-05-01", "tillDate": "2029-05-31" }
  ],
    "Preset 2": [
      { "dateFrom": "2016-05-04", "tillDate": "2016-06-14" },
      { "dateFrom": "2017-05-04", "tillDate": "2017-06-14" },
      { "dateFrom": "2018-05-04", "tillDate": "2018-06-14" },
      { "dateFrom": "2019-05-04", "tillDate": "2019-06-14" },
      { "dateFrom": "2020-05-04", "tillDate": "2020-06-14" },
      { "dateFrom": "2021-05-04", "tillDate": "2021-06-14" },
      { "dateFrom": "2022-05-04", "tillDate": "2022-06-14" },
      { "dateFrom": "2023-05-04", "tillDate": "2023-06-14" },
      { "dateFrom": "2024-05-04", "tillDate": "2024-06-14" },
      { "dateFrom": "2025-05-04", "tillDate": "2025-06-14" },
      { "dateFrom": "2026-05-04", "tillDate": "2026-06-14" },
      { "dateFrom": "2027-05-04", "tillDate": "2027-06-14" },
      { "dateFrom": "2028-05-04", "tillDate": "2028-06-14" },
      { "dateFrom": "2029-05-04", "tillDate": "2029-06-14" }
    ],
    "Custom" : [{}],
  };

  const handlePresetChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedPreset(selectedValue);

    // When preset is selected, set formData.holidays to corresponding preset data
    if (selectedValue) {
      setFormData({ ...formData, holidays: presets[selectedValue] });
    } else {
      // Reset to empty if no preset selected
      setFormData({ ...formData, holidays: [] });
    }
  };

  const onTableDataChange = (rows) => {
    // Ensure all dates in rows are in yyyy-MM-dd format before updating formData
    const formattedRows = rows.map((row) => ({
      ...row,
      dateFrom: formatDateToInput(row.dateFrom),
      tillDate: formatDateToInput(row.tillDate),
    }));
    setFormData({ ...formData, holidays: formattedRows });
  };

  useEffect(() => {
  }, [formData]);


  return (
    <form  className="google_forms">
           <div className="forms">
      <div className="arrears-seventh-form3">
        
         {/* Add checkbox to enable or disable editing */}
         <label>
          <CheckboxInput
            value={formData.isHoliday}
            onChange={handleInputChange}
            name="isHoliday"
            label="Holiday:"
          />
          </label>

        {formData.isHoliday && (
          <>
        <label>
          Select a Preset:
          <select onChange={handlePresetChange} value={selectedPreset}>
            <option value="">-- Select Preset --</option>
            <option value="Preset 1">Senior College</option>
            <option value="Preset 2">High School</option>
            <option value="Custom">Custom</option>

          </select>
        </label>

        {/* Dynamic Table to display preset values */}
        <DynamicTable
          tableName="Holidays"
          columns={[
            { header: "Date From", key: "dateFrom", type: "date" },
            { header: "Till Date", key: "tillDate", type: "date" },
          ]}
          localStorageKey="holidays"
          onTableDataChange={onTableDataChange}
          rows={formData.holidays || []} // Ensure this is passed as the rows prop
          hasPreset={true}
        />
         </>
        )}
      </div>

      {/* Navigation Buttons */}
      <div className="seventh-pay-arrears-buttons-container">
        <button type="button" onClick={onBack}>
          Back
        </button>
        <button type="button" onClick={() => {onNext();}}>
         Next
        </button>
        </div>
        </div>
    </form>
   

  );
};

export default ArrearsSeventhForm3;
